import * as React from 'react';
import Typography from '@mui/material/Typography';
import HomeIcon from '@mui/icons-material/Home';
import Button from "@mui/material/Button";
import {Stack} from "@mui/material";
import {Link} from "react-router-dom";

export default function NoResults() {
    return (
        <Stack>
            <Typography marginBottom={1} variant="h4">No results found</Typography>
            <Typography marginBottom={2}>We couldn't find any items matching your criteria. Try to refine your query.
            </Typography>
            <Button variant="outlined" component={Link} to={"/mom"}>
                <HomeIcon/>Back to Homepage
            </Button>

        </Stack>
    );
}

